import { render, staticRenderFns } from "./Registrations.container.vue?vue&type=template&id=660cc812&scoped=true&"
import script from "./Registrations.container.vue?vue&type=script&lang=js&"
export * from "./Registrations.container.vue?vue&type=script&lang=js&"
import style0 from "./Registrations.container.vue?vue&type=style&index=0&id=660cc812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660cc812",
  null
  
)

export default component.exports